import React, { useEffect, useState } from 'react'
import { Spacer } from '../..'
import TokenDummyHash from '../../../../src/data-dummy/token-hash.json';
import './Application.scss';

function Application({ id }) {

  const [token, setToken] = useState([])
  useEffect(() => {
    setToken(TokenDummyHash['token-hash'])
  }, [token])

  return (
    <div className="row">
      <div className="col-xl-6 mb-3">
        <div className="cardContainer">
          <span className="titleApp">{id}</span>
          <Spacer h={20} />
          <video className="videoPlayer" controls src="/media/video-dummy.mp4" />
        </div>
      </div>
      <div className="col-xl-6 mb-3">
        <div className="cardContainer">
          <div className="cardUtil">
            <span className="titleCard d-block">A Bit Proof of Work</span>
            <small className="text-muted">Lorem ipsum dolor</small>
          </div>
          <div className="table-responsive tableScroll scrollCustom" style={{ height: 290 }}>
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Hash</th>
                  <th>Detail</th>
                </tr>
              </thead>
              <tbody>
                {
                  token.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>{item.hash}</td>
                        <td>{item.detail}</td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Application
